import router from "./router/main";
import ErrorComponent from "./components/common/Error"

export function handleError (response, commit) {
    if(response.response === undefined) {
        //console.log(response)
    }
    else if(response.response.status === 401) {
        commit('user/logOut', null, {root: true});
        router.push({name: 'Login'});
        return false;
    } else if(response.response.status === 403) {
        router.push({name: 'ClientApp'});
        return false;
    } else if (response.name === 'Error') {
        commit('setPopupComponent', ErrorComponent, { root: true });
        commit('setPopupData', {message: response.response.data.message}, { root: true });
        commit('switchPopup', true, { root: true });
        return false
    }

}

export function toggleBodyClass(addRemoveClass, className) {
    const el = document.body;

    if (addRemoveClass === 'addClass') {
        el.classList.add(className);
    } else {
        el.classList.remove(className);
    }
}